import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";

export default function ProductDetailsSkeleton() {
  return (
    <div className="container mx-auto py-8 px-4 md:px-6 lg:px-8">
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
        {/* Product Image Gallery Skeleton */}
        <div className="flex flex-col items-center">
          {/* Main Image Skeleton */}
          <Skeleton className="w-full max-w-md aspect-square rounded-lg" />

          {/* Thumbnail Images Skeleton */}
          <div className="flex gap-2 mt-4">
            {Array.from({ length: 3 }).map((_, index) => (
              <Button
                key={index}
                variant="ghost"
                size="icon"
                className="w-16 h-16 rounded-md border"
                disabled
              >
                <Skeleton className="w-full h-full rounded-md" />
              </Button>
            ))}
          </div>
        </div>

        {/* Product Details Skeleton */}
        <div className="flex flex-col gap-6">
          {/* Title Skeleton */}
          <div>
            <Skeleton className="w-3/4 h-8 mb-2" />
            <div className="flex items-center gap-2 mt-2">
              <Skeleton className="w-24 h-5" />
              <Skeleton className="w-20 h-5" />
            </div>
            <Skeleton className="w-32 h-10 mt-4" />
          </div>

          {/* Description Skeleton */}
          <div className="space-y-2">
            <Skeleton className="w-full h-4" />
            <Skeleton className="w-full h-4" />
            <Skeleton className="w-5/6 h-4" />
          </div>

          {/* Key Benefits Skeleton */}
          <div className="grid gap-2">
            <Skeleton className="w-32 h-6" />
            <div className="space-y-2">
              <Skeleton className="w-full h-4" />
              <Skeleton className="w-4/5 h-4" />
              <Skeleton className="w-3/4 h-4" />
            </div>
          </div>

          {/* Ingredients Skeleton */}
          <div className="grid gap-2">
            <Skeleton className="w-28 h-6" />
            <Skeleton className="w-full h-20" />
          </div>

          {/* Stock & SKU Skeleton */}
          <div className="grid gap-2">
            <Skeleton className="w-40 h-5" />
            <Skeleton className="w-32 h-5" />
          </div>

          {/* Quantity & Add to Cart Skeleton */}
          <div className="flex items-center gap-4 mt-4">
            <div className="flex items-center border rounded-md">
              <Skeleton className="w-10 h-10" />
              <Skeleton className="w-16 h-10" />
              <Skeleton className="w-10 h-10" />
            </div>
            <Skeleton className="flex-1 h-12 rounded-md" />
          </div>
        </div>
      </div>
    </div>
  );
}

